// This is the main entry point for the block view script - Image Slider
function SliderInit() {
	const blockId = slider_block_id;
	const slides = slider_slides;

	// Get all slide elements
	const slideElements = document.querySelectorAll(`.block-${blockId}-slider-slide`);
	const dotElements = document.querySelectorAll(`.block-${blockId}-slider-dot`);

	let currentSlide = 0;

	// Function to show a specific slide with ease-in-out transition
	function showSlide(index) {
		// Remove active class from all slides and dots
		slideElements.forEach((slide) => {
			slide.classList.remove('active');
		});

		dotElements.forEach((dot) => {
			dot.classList.remove('active');
		});

		// Add active class to the selected slide and dot
		if (slideElements[index]) {
			slideElements[index].classList.add('active');
		}

		if (dotElements[index]) {
			dotElements[index].classList.add('active');
		}

		currentSlide = index;

		// Save current slide to localStorage
		localStorage.setItem(`slider-${blockId}-current`, index);
	}

	// Add click event listeners to dots
	dotElements.forEach((dot, index) => {
		dot.addEventListener('click', () => {
			showSlide(index);
		});
	});

	// Check if there's a saved slide position
	const savedSlide = localStorage.getItem(`slider-${blockId}-current`);
	if (savedSlide !== null && parseInt(savedSlide) < slideElements.length) {
		showSlide(parseInt(savedSlide));
	} else {
		showSlide(0);
	}

	// Optional: Auto-advance slides every 5 seconds
	// Uncomment the following lines to enable auto-play
	/*
	setInterval(() => {
		const nextSlide = (currentSlide + 1) % slideElements.length;
		showSlide(nextSlide);
	}, 5000);
	*/
}

// Initialize the slider when the script loads
SliderInit();
